import { ADD_SINGLE_ATTACHMENT } from "../../../enums/Request/request.types";

export const addOneAttachmentAction = (data) => {
    return {
        type: ADD_SINGLE_ATTACHMENT,
        payload: data,
    };
};
